import React, {useState, useCallback, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import dateformat from 'dateformat';
import {getCookie} from '../../../../utils/getCookie';
//import { supportRequestList } from '../../data/mockdata';
import noDataPng from '../assets/no-request.png';
import RefundRaiseRequestListing from '../RefundRaiseRequestListing/RefundRaiseRequestListing';
import RefundRaiseRequestHeader from '../RefundRequestHeader/RefundRaiseRequestHeader';
import NoRequests from '../NoRequests/NoRequests';
import * as S from './RefundRequestRaiseContainer.styles';

const RefundRequestRaiseContainer = ({sendTrackingDataToSdk}) => {
  const dispatch = useDispatch();
  const [requestModal, setRequestModal] = useState(true);
  const [searchDate, setSearchDate] = useState({});
  const [listData1, setListData1] = useState([]);
  const [modalFlag, setModalFlag] = useState(false);
  const [listData, setListData] = useState([]);

  const ccdeCookie = getCookie('ccde');

  return (
    <S.SupportPgContainer>
      <RefundRaiseRequestHeader
        setSearchDate={setSearchDate}
        setListData={setListData}
        modalFlag={modalFlag}
        setModalFlag={setModalFlag}
        listData={listData}
        sendTrackingDataToSdk={sendTrackingDataToSdk}
      />
      {listData.length ? (
        <RefundRaiseRequestListing listingData={listData} />
      ) : (
        <NoRequests
          icon={noDataPng}
          heading="No Request Found!"
          description={
            ccdeCookie === 'AE'
              ? 'Raise your wallet deposit request here'
              : 'Raise request here in case you have deposited the money but the <span>wallet balance is not updated after 3 hours.</span>'
          }
          cta="Raise Request"
          setModalFlag={setModalFlag}
        />
      )}
    </S.SupportPgContainer>
  );
};

export default RefundRequestRaiseContainer;
